import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackDowngradeInitiated.meta';

export type UseTrackCreditPackDowngradeInitiatedParams = CreditAnalyticsParams & {
  pack_quantity: number;
  source?: OpenCreditPackModalLocations;
};

export const useTrackCreditPackDowngradeInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackDowngradeInitiated = useCallback(
    (params: UseTrackCreditPackDowngradeInitiatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackDowngradeInitiated };
};
